import moment from "moment";
// Parse the time to string
export const parseTime = (
  time?: object | string | number,
  cFormat?: string
): string | null => {
  if (!time) return "";

  const format = cFormat || "YYYY-MM-DD HH:mm:ss";

  return moment(time).format(format);
};
export const dateTime = (
  time?: object | string | number,
  cFormat?: string
): string | null => {
  if (!time) return "";

  const format = cFormat || "MM-DD";

  return moment(time).format(format);
};
export const hoursS = (
  time?: object | string | number,
  cFormat?: string
): string | null => {
  if (!time) return "";

  const format = cFormat || "HH:mm";

  return moment(time).format(format);
};
export function parseDate(dateStr: string) {
  return moment(dateStr).format("YYYY年MM月DD日");
}
// Format and filter json data using filterKeys array
export const formatJson = (filterKeys: any, jsonData: any) =>
  jsonData.map((data: any) =>
    filterKeys.map((key: string) => {
      if (key === "timestamp") {
        return parseTime(data[key]);
      } else {
        return data[key];
      }
    })
  );

// Check if an element has a class
export const hasClass = (ele: HTMLElement, className: string) => {
  return !!ele.className.match(new RegExp("(\\s|^)" + className + "(\\s|$)"));
};

// Add class to element
export const addClass = (ele: HTMLElement, className: string) => {
  if (!hasClass(ele, className)) ele.className += " " + className;
};

// Remove class from element
export const removeClass = (ele: HTMLElement, className: string) => {
  if (hasClass(ele, className)) {
    const reg = new RegExp("(\\s|^)" + className + "(\\s|$)");
    ele.className = ele.className.replace(reg, " ");
  }
};

// Toggle class for the selected element
export const toggleClass = (ele: HTMLElement, className: string) => {
  if (!ele || !className) {
    return;
  }
  let classString = ele.className;
  const nameIndex = classString.indexOf(className);
  if (nameIndex === -1) {
    classString += "" + className;
  } else {
    classString =
      classString.substr(0, nameIndex) +
      classString.substr(nameIndex + className.length);
  }
  ele.className = classString;
};
